import { StringChoiceModel } from "models/ChoiceModel";
import { TranslationsContextProps } from "providers";

export function getParticipantRoles(i18n: TranslationsContextProps): StringChoiceModel[] {
  return [
    {
      value: "Vorsitz",
      name: "Chair",
      text: i18n.ParticipantRole_Chair,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
    {
      value: "Protokoll",
      name: "Protocol",
      text: i18n.ParticipantRole_Protocol,
      tooltip: "",
      disabled: false,
      isDefault: false,
    },
  ];
}
